var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillLinksActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_288_629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_288_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14V12C4.23333 12 5.39583 11.7625 6.4875 11.2875C7.57917 10.8125 8.53333 10.1667 9.35 9.35C10.1667 8.53333 10.8125 7.57917 11.2875 6.4875C11.7625 5.39583 12 4.23333 12 3H14C14 4.51667 13.7125 5.94167 13.1375 7.275C12.5625 8.60833 11.775 9.775 10.775 10.775C9.775 11.775 8.60833 12.5625 7.275 13.1375C5.94167 13.7125 4.51667 14 3 14ZM3 10V8C4.38333 8 5.5625 7.5125 6.5375 6.5375C7.5125 5.5625 8 4.38333 8 3H10C10 4.93333 9.31667 6.58333 7.95 7.95C6.58333 9.31667 4.93333 10 3 10ZM3 6V3H6C6 3.83333 5.70833 4.54167 5.125 5.125C4.54167 5.70833 3.83333 6 3 6ZM10 21C10 19.4833 10.2875 18.0583 10.8625 16.725C11.4375 15.3917 12.225 14.225 13.225 13.225C14.225 12.225 15.3917 11.4375 16.725 10.8625C18.0583 10.2875 19.4833 10 21 10V12C19.7667 12 18.6042 12.2375 17.5125 12.7125C16.4208 13.1875 15.4667 13.8333 14.65 14.65C13.8333 15.4667 13.1875 16.4208 12.7125 17.5125C12.2375 18.6042 12 19.7667 12 21H10ZM14 21C14 19.0667 14.6833 17.4167 16.05 16.05C17.4167 14.6833 19.0667 14 21 14V16C19.6167 16 18.4375 16.4875 17.4625 17.4625C16.4875 18.4375 16 19.6167 16 21H14ZM18 21C18 20.1667 18.2917 19.4583 18.875 18.875C19.4583 18.2917 20.1667 18 21 18V21H18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLinksActive);
export default __webpack_public_path__ + "static/media/Skill-links-active.8520eadaf5658e4efae13a7fb63dff29.svg";
export { ForwardRef as ReactComponent };